<template>
	<van-popup class="region" v-model="show" round position="bottom">
		<van-form @submit="handleSubmit">
			<van-field v-model="region.orgNum" label="机构代码" :readonly="pattern === 'edit'"
				placeholder="请输入营业执照上的统一社会信用代码" />
			<van-field v-model="region.orgName" :rules="[{ required: true, message: '请填写机构名称', trigger: 'onBlur' }]"
				label="机构名称" :readonly="pattern === 'edit'" placeholder="请输入所属机构" />

			<!-- :value="followUpPerson" -->
			<van-field v-model="provinces" label="省/市/区县" placeholder="请选择省/市/区县" readonly @click="ishow" />
			<van-field v-model="address" label="地址" right-icon="search" placeholder="请输入地址"
				@click-right-icon='righticonsearch' @input="righticonsearch"/>
			<!-- <van-field
        v-model="region.orgAddress"
        id="address-input"
        label="地址"
        clearable
        :readonly="pattern === 'edit'"
        placeholder="请输入所在位置"
        @clear="clearAddress"
      /> -->
			<div ref="map" id="map" />
			<div v-if="pattern === 'add'" class="footer">
				<van-button type="info" size="small" native-type="submit">确定</van-button>
				<van-button size="small" @click="show = false">取消</van-button>
			</div>
		</van-form>
		<!-- 省市区下拉框 -->
		<my-address-cascade ref="address" v-if="isShowAdds" :columnsNum="3" :defaultValue="defaultValue"
			@addressCallback="addressCallback"></my-address-cascade>
	</van-popup>
</template>

<script>
	import {
		loadMap
	} from '@/utils';
	import {
		getlatandlngbyaddress
	} from '@/api/common'
	import myAddressCascade from '@/components/region/addressCascade.vue'
	export default {
		name: 'Region',
		components: {
			myAddressCascade
		},
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			value: {
				type: Object,
				default: () => ({
					orgNum: '',
					orgName: '',
					orgAddress: '',
					lng: undefined,
					lat: undefined
				})
			},
			pattern: {
				type: String,
				default: 'add',
				validator: (value) => {
					return ['add', 'edit'].includes(value)
				}
			}
		},
		data() {
			return {
				mapInstance: null,
				markerInstance: null,
				region: {
					orgNum: '',
					orgName: '',
					orgAddress: '',
					lng: undefined,
					lat: undefined
				},
				isShowAdds: false,
				defaultValue: 110101,
				provinces: '',
				address: ''
			}
		},
		computed: {
			show: {
				get() {
					return this.visible
				},
				set(val) {
					this.$emit('update:visible', val)
				}
			}
		},
		created() {
			console.log(123456, this.value)
			if (this.value.district) {
				this.defaultValue = Number(this.value.district) || 110101
				if(this.value.provinceName){
					this.provinces = this.value.provinceName + this.value.cityName + this.value.districtName
				}else{
					this.provinces = this.value.areaIdsDesc
				}
				let text = `${this.provinces}`
				this.address = this.value.orgAddress.replace(text, '')

			}
			this.isShowAdds = false
			this.$nextTick(() => {
				this.initMap()
			})
			this.region = {
				...this.value
			}
		},
		beforeDestroy() {
			if (this.mapInstance) {
				this.mapInstance.destroy()
			}
		},
		methods: {
			ishow(){
				if(this.$refs.address) this.$refs.address.$data.isAddress = true
				this.isShowAdds = true
			},
			righticonsearch() {
				if (!this.provinces) return this.$toast('请选择省/市/区县')
				if (!this.address) return this.$toast('请输入地址')
				getlatandlngbyaddress({
					address: `${this.provinces}${this.address}`
				}).then(res => {
					if (res.data.length) {
						const data = res.data[0]
						const location = data.location.split(',')
						console.log(location[0], location[1])
						this.markEvent(location[0], location[1])
					}
				})
			},
			// 选择城市
			addressCallback(obj, num) {
				console.log(123465, obj, num)
				this.provinces = obj.address.join('') || ''
				this.region.provinceName = obj.address[0]
				this.region.cityName = obj.address[1]
				this.region.districtName = obj.address[2]
				this.region.province = obj.code[0]
				this.region.city = obj.code[1]
				this.region.district = obj.code[2]
				this.region.adcode = obj.code[2]
				this.defaultValue = Number(obj.code[2]) || 110101
				this.isShowAdds = false
			},
			handleSubmit() {
				if (!this.provinces) return this.$toast('请选择省/市/区县')
				if (!this.address) return this.$toast('请输入地址')
				this.region.orgAddress = `${this.provinces}${this.address}`
				this.show = false
				this.$emit('saveRegion', this.region)
			},
			clearAddress() {
				Object.assign(this.region, {
					orgAddress: '',
					lng: undefined,
					lat: undefined
				})
			},
			initMap() {
				if (this.mapInstance) {
					this.mapInstance.destroy()
				}
				if (this.$refs.map) {
					loadMap().then((AMap) => {
						this.markerInstance = new AMap.Marker()
						this.mapInstance = new AMap.Map(this.$refs.map, {
							resizeEnable: true, // 是否监控地图容器尺寸变化
							zoom: 16, // 初始化地图层级
							zooms: [11, 19]
						})
						var {
							lng,
							lat
						} = this.region
						this.mapInstance.on('complete', () => {
							// this.initMapUI()
							if (lng && lat) { // 如果经纬度存在，设置地图中心为当前
								this.markEvent(lng, lat)
							}
						})
					})
				}
			},
			markEvent(lng, lat) {
				const position = new AMap.LngLat(lng, lat)
				this.mapInstance.setCenter(position)
				this.markerInstance.setMap(this.mapInstance)
				this.markerInstance.setMap(this.mapInstance)
				this.markerInstance.setPosition(position)
			},
			initMapUI() { // 初始化地图UI
				window.AMapUI.loadUI(['misc/PoiPicker'], (PoiPicker) => {
					const poiPicker = new PoiPicker({
						input: 'address-input'
					})
					this.poiPickerReady(poiPicker)
				})
			},
			poiPickerReady(poiPicker) {
				poiPicker.on('poiPicked', (res) => {
					const {
						item
					} = res;
					const {
						location,
						address,
						district,
						name
					} = item
					Object.assign(this.region, {
						orgAddress: `${district}${address}${name}`,
						lng: location ? `${location.lng}` : undefined,
						lat: location ? `${location.lat}` : undefined
					})
					this.markerInstance.setPosition(location)
					this.mapInstance.setCenter(this.markerInstance.getPosition())
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.region {
		.van-field {
			overflow: unset;

			/deep/ .van-field__label {
				margin-right: 0;
				width: 5em;
			}

			/deep/ .van-field__body {
				font-size: 12px;
			}
		}

		#map {
			height: 300px;
			margin-top: 10px;
		}

		.footer {
			padding: 10px 0;
			text-align: center;

			.van-button {
				width: 100px;

				&:first-of-type {
					margin-right: 50px;
				}
			}
		}

		/deep/ .amap-ui-poi-picker-sugg-container {
			max-height: 300px;
		}
	}
</style>
